import Model from './base';

export class Discount extends Model {
  resource() {
    return 'catalog/discount';
  }

  defaultAttributes() {
    return {
        discount_type: null,
        discount: null,
        name: null,
        description: {},
    }
  }
}


export class DiscountItem extends Model {
  resource() {
    return 'catalog/discount-item';
  }

  defaultAttributes() {
    return {
        discount: null,
        articul: null,
        product: {},
        min_qnt: null,
        value: null
    }
  }
}

